import listViewStore from 'owa-mail-list-store/lib/store/Store';
import mailStore from 'owa-mail-store/lib/store/Store';
import * as React from 'react';
import MailListItemPart from './MailListItemPart';
import MailListItemExpansionLoadMoreButton from './MailListItemExpansionLoadMoreButton';
import isNewestOnBottom from 'owa-mail-reading-pane-store/lib/utils/isNewestOnBottom';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { observer } from 'mobx-react';
import Draggable from 'owa-dnd/lib/components/Draggable';
import { MAIL_ITEM_DRAG_YOFFSET, MAIL_ITEM_DRAG_XOFFSET, getMailListItemPartDragPreview, } from '../utils/mailListDragUtil';
import { getItemToShowFromNodeId } from 'owa-mail-store/lib/utils/conversationsUtils';
import strings from 'owa-strings/owa-mail-strings';
import { DraggableItemTypes } from 'owa-dnd/lib/utils/DraggableItemTypes';
var styles = require('./MailListItemPart.scss');
export default observer(function MailListItemExpansion(props) {
    var conversationItem = listViewStore.conversationItems.get(props.conversationId);
    var displayItemParts = conversationItem.globalItemIds.length > 1;
    var conversationItemParts = mailStore.conversations.get(conversationItem.id);
    var shouldShowLoadMore = conversationItemParts &&
        conversationItemParts.canLoadMore &&
        isMailFeatureEnabled('tri-superConversationExpansion');
    var isNewestItemsOnBottom = isNewestOnBottom();
    return displayItemParts && conversationItemParts ? (React.createElement("div", { className: styles.expansionContainer },
        shouldShowLoadMore &&
            isNewestItemsOnBottom &&
            renderLoadMoreButton(conversationItem.clientId, conversationItemParts.isLoadMoreInProgress, isNewestItemsOnBottom, props.isSingleLine),
        React.createElement(Draggable, { canDrag: canDrag, getDragData: function () { return getMailListExpansionDragData(props.tableViewId); }, getDragPreview: getMailListItemPartDragPreview, xOffset: MAIL_ITEM_DRAG_XOFFSET, yOffset: MAIL_ITEM_DRAG_YOFFSET }, conversationItemParts.conversationNodeIds.length > 0 &&
            conversationItemParts.conversationNodeIds.map(function (nodeId) { return (React.createElement(MailListItemPart, { nodeId: nodeId, tableViewId: props.tableViewId, isSingleLine: props.isSingleLine, tableViewSupportsFlagging: props.tableViewSupportsFlagging })); })),
        shouldShowLoadMore &&
            !isNewestItemsOnBottom &&
            renderLoadMoreButton(conversationItem.clientId, conversationItemParts.isLoadMoreInProgress, isNewestItemsOnBottom, props.isSingleLine))) : null;
});
var canDrag = function () {
    return (isMailFeatureEnabled('tri-superConversationExpansion') &&
        listViewStore.expandedConversationViewState.selectedNodeIds.length > 0);
};
var getMailListExpansionDragData = function (tableViewId) {
    // Also rename this to getMailListRowDragData. May be get this information from the mailRowData getter api
    var itemIds = [];
    var subjects = [];
    var selectedNodeIds = listViewStore.expandedConversationViewState.selectedNodeIds;
    selectedNodeIds.forEach(function (nodeId) {
        var item = getItemToShowFromNodeId(nodeId);
        if (item) {
            subjects.push(item.Subject ? item.Subject : strings.noSubject);
            itemIds.push(item.ItemId.Id);
        }
    });
    return {
        itemType: DraggableItemTypes.MailListItemPart,
        tableViewId: tableViewId,
        subjects: subjects,
        itemIds: itemIds,
    };
};
var renderLoadMoreButton = function (conversationId, isLoadMoreInProgress, isNewestOnBottom, isSingleLine) {
    return (React.createElement(MailListItemExpansionLoadMoreButton, { conversationId: conversationId, isLoadMoreInProgress: isLoadMoreInProgress, isSingleLineView: isSingleLine, isNewestOnBottom: isNewestOnBottom }));
};
//# sourceMappingURL=MailListItemExpansion.js.map